import { Radio } from "@blueprintjs/core"
import React, { useContext } from "react"
import classNames from "utils/classNames"
import { RadioGroupContext } from "./CustomRadioGroup"

export type CustomRadioProps = {
  className?: string
  id?: any
  name?: string
  disabled?: boolean
  inline?: boolean
  large?: boolean
  tagName?: keyof JSX.IntrinsicElements
}
const CustomRadio = ({
  className,
  id,
  name,
  disabled,
  inline,
  large,
  tagName,
}: CustomRadioProps) => {
  const { value, onSelect } = useContext(RadioGroupContext)
  return (
    <Radio
      checked={value === id}
      className={classNames("vt-custom-radio", className)}
      label={name}
      name={id.toString()}
      disabled={disabled}
      inline={inline}
      large={large}
      tagName={tagName}
      onChange={e => onSelect(id)}
    />
  )
}

export default CustomRadio
